import { max as max_2, numberHash, arrayHash, equalArrays, stringHash, compare, comparePrimitives, createAtom } from "./.fable/fable-library.3.1.5/Util.js";
import { cons, append, empty, mapIndexed as mapIndexed_1, filter, collect as collect_1, groupBy, sort, singleton, sortBy, item, length, max, tryItem, min, map as map_1, ofSeq, choose, ofArray } from "./.fable/fable-library.3.1.5/List.js";
import { FSharpRef, Union, Record } from "./.fable/fable-library.3.1.5/Types.js";
import { option_type, tuple_type, union_type, record_type, list_type, int32_type, string_type, float64_type } from "./.fable/fable-library.3.1.5/Reflection.js";
import { MapProps_Style_7213C43C, MapProps, CircleProps_Custom_433E080, CircleProps, PolylineProps, CircleProps$reflection, PolylineProps$reflection } from "./.fable/Fable.ReactLeaflet.1.0.0/ReactLeaflet.fs.js";
import { tryParse as tryParse_1, parse as parse_1 } from "./.fable/fable-library.3.1.5/Double.js";
import { tryParse } from "./.fable/fable-library.3.1.5/Int32.js";
import { iterate, sumBy, filter as filter_1, empty as empty_1, exists, singleton as singleton_1, append as append_1, delay, max as max_1, minBy, min as min_1, concat, mapIndexed, collect, head, map } from "./.fable/fable-library.3.1.5/Seq.js";
import { toConsole, join, printf, toText, split as split_1 } from "./.fable/fable-library.3.1.5/String.js";
import { toArray, some, map as map_2, defaultArg, bind } from "./.fable/fable-library.3.1.5/Option.js";
import { toList, FSharpMap__get_Item, ofSeq as ofSeq_1 } from "./.fable/fable-library.3.1.5/Map.js";
import { distinct } from "./.fable/fable-library.3.1.5/Set.js";
import { data as data_1 } from "./Data.fs.js";
import { Cmd_ofSub, Cmd_none } from "./.fable/Fable.Elmish.3.1.0/cmd.fs.js";
import * as react from "react";
import { Option, button as button_1 } from "./.fable/Fulma.2.10.0/Elements/Button.fs.js";
import { TextAlignment_Option, Screen, Modifier_IModifier, Color_IColor } from "./.fable/Fulma.2.10.0/Common.fs.js";
import { Item_div, Start_div, Brand_div, Option as Option_1, navbar } from "./.fable/Fulma.2.10.0/Components/Navbar.fs.js";
import { h2 } from "./.fable/Fulma.2.10.0/Elements/Heading.fs.js";
import { footer as footer_1, title as title_1 } from "./Config.fs.js";
import { Option as Option_2, columns as columns_1 } from "./.fable/Fulma.2.10.0/Layouts/Columns.fs.js";
import { column } from "./.fable/Fulma.2.10.0/Layouts/Column.fs.js";
import { TileLayer, Map as Map$, Polyline, Tooltip, Popup, Circle } from "react-leaflet";
import { keyValueList } from "./.fable/fable-library.3.1.5/MapUtil.js";
import { CSSProp } from "./.fable/Fable.React.7.2.0/Fable.React.Props.fs.js";
import { footer } from "./.fable/Fulma.2.10.0/Layouts/Footer.fs.js";
import { Option as Option_3, content } from "./.fable/Fulma.2.10.0/Elements/Content.fs.js";
import { ProgramModule_mkProgram, ProgramModule_withSubscription, ProgramModule_run } from "./.fable/Fable.Elmish.3.1.0/program.fs.js";
import { Program_withReactBatched } from "./.fable/Fable.Elmish.React.3.0.1/react.fs.js";

export const USE_ARROWS = true;

export const animationActive = createAtom(false);

export function posOnLine(fraction, x1, y1, x2, y2) {
    const patternInput = (x1 > x2) ? [x2, x1] : [x1, x2];
    const x1_1 = patternInput[0];
    const patternInput_1 = (y1 > y2) ? [y2, y1] : [y1, y2];
    const y1_1 = patternInput_1[0];
    return [x1_1 + (fraction * (patternInput[1] - x1_1)), y1_1 + (fraction * (patternInput_1[1] - y1_1))];
}

export function arrowPolyLine(headlen, fromx, fromy, tox, toy) {
    const patternInput = posOnLine(0.5, fromx, fromy, tox, toy);
    const arrowy = patternInput[1];
    const arrowx = patternInput[0];
    const angle = Math.atan2(toy - fromy, tox - fromx);
    return ofArray([[arrowx - (headlen * Math.cos(angle - (3.141592653589793 / 6))), arrowy - (headlen * Math.sin(angle - (3.141592653589793 / 6)))], [arrowx, arrowy], [arrowx - (headlen * Math.cos(angle + (3.141592653589793 / 6))), arrowy - (headlen * Math.sin(angle + (3.141592653589793 / 6)))]]);
}

export class Marker extends Record {
    constructor(Latitude, Longitude, Ident, Title, Weight, Year, Properties) {
        super();
        this.Latitude = Latitude;
        this.Longitude = Longitude;
        this.Ident = Ident;
        this.Title = Title;
        this.Weight = Weight;
        this.Year = (Year | 0);
        this.Properties = Properties;
    }
}

export function Marker$reflection() {
    return record_type("Client.Marker", [], Marker, () => [["Latitude", float64_type], ["Longitude", float64_type], ["Ident", string_type], ["Title", string_type], ["Weight", float64_type], ["Year", int32_type], ["Properties", list_type(string_type)]]);
}

export class PropertyDef extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EdgeProperty", "VectorProperty"];
    }
}

export function PropertyDef$reflection() {
    return union_type("Client.PropertyDef", [], PropertyDef, () => [[["Item", PolylineProps$reflection()]], [["Item", CircleProps$reflection()]]]);
}

export const grey = "#848484";

export const mkProperties = (list) => choose((s) => {
    const _arg1 = ofArray(s.split("="));
    let pattern_matching_result, r;
    if (_arg1.tail != null) {
        if (_arg1.head === "edgeColorGrey") {
            if (_arg1.tail.tail != null) {
                if (_arg1.tail.head === "") {
                    if (_arg1.tail.tail.tail == null) {
                        pattern_matching_result = 0;
                    }
                    else {
                        pattern_matching_result = 3;
                    }
                }
                else {
                    pattern_matching_result = 3;
                }
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else if (_arg1.head === "nodeColorGrey") {
            if (_arg1.tail.tail != null) {
                if (_arg1.tail.head === "") {
                    if (_arg1.tail.tail.tail == null) {
                        pattern_matching_result = 1;
                    }
                    else {
                        pattern_matching_result = 3;
                    }
                }
                else {
                    pattern_matching_result = 3;
                }
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else if (_arg1.head === "radius") {
            if (_arg1.tail.tail != null) {
                if (_arg1.tail.tail.tail == null) {
                    pattern_matching_result = 2;
                    r = _arg1.tail.head;
                }
                else {
                    pattern_matching_result = 3;
                }
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else {
            pattern_matching_result = 3;
        }
    }
    else {
        pattern_matching_result = 3;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new PropertyDef(0, new PolylineProps(4, grey));
        }
        case 1: {
            return new PropertyDef(1, new CircleProps(4, grey));
        }
        case 2: {
            return new PropertyDef(1, new CircleProps(17, parse_1(r)));
        }
        case 3: {
            return void 0;
        }
    }
}, list);

export const nl = "\n";

export function tryInt(s) {
    let patternInput;
    let outArg = 0;
    patternInput = [tryParse(s, 511, false, 32, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (patternInput[0]) {
        return patternInput[1];
    }
    else {
        return void 0;
    }
}

export function tryFloat(s) {
    let patternInput;
    let outArg = 0;
    patternInput = [tryParse_1(s, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (patternInput[0]) {
        return patternInput[1];
    }
    else {
        return void 0;
    }
}

export function split(sep, s) {
    return ofSeq(map((s_1) => s_1.trim(), split_1(s, [sep], null, 0)));
}

export function lines(s) {
    return split(nl, s);
}

export function columns(s) {
    return split("\t", s);
}

export function parse(s) {
    return map_1((s_2) => columns(s_2), lines(s));
}

export function mkData(s) {
    const defaultYear = 0;
    const xs = parse(s);
    const yMin = min(choose((x) => bind((s_1) => tryInt(s_1), tryItem(2, x)), xs), {
        Compare: (x_1, y) => comparePrimitives(x_1, y),
    }) | 0;
    const yMax = max(choose((x_2) => bind((s_2) => tryInt(s_2), tryItem(2, x_2)), xs), {
        Compare: (x_3, y_1) => comparePrimitives(x_3, y_1),
    }) | 0;
    return choose((x_6) => {
        let s_4;
        if (length(x_6) < 6) {
            return void 0;
        }
        else {
            const lnglat = split(",", (s_4 = item(1, x_6), (s_4.trim() === "") ? "50.0872, 14.4211" : s_4.trim()));
            const lng = item(0, lnglat);
            const lat = item(1, lnglat);
            const year = defaultArg(tryInt(item(2, x_6)), defaultYear) | 0;
            const loc = item(0, x_6);
            const name = item(3, x_6);
            const weight = (year - yMin) / (yMax - yMin);
            let title;
            const arg50 = defaultArg(tryItem(5, x_6), "");
            const arg40 = defaultArg(tryItem(4, x_6), "");
            title = toText(printf("%s - %s - %i - %s %s"))(loc)(name)(year)(arg40)(arg50);
            const ident = defaultArg(map_2((y_3) => toText(printf("%s - %s"))(name)(y_3), tryItem(6, x_6)), name);
            const defProp = (year === defaultYear) ? "nodeColorGrey" : "";
            const properties = split(",", defaultArg(tryItem(7, x_6), defProp));
            return new Marker(parse_1(lat), parse_1(lng), ident, title, weight, year, properties);
        }
    }, sortBy((x_4) => bind((s_3) => tryInt(s_3), tryItem(2, x_4)), xs, {
        Compare: (x_5, y_2) => compare(x_5, y_2),
    }));
}

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Map", "LoadData", "LocationTree"];
    }
}

export function Page$reflection() {
    return union_type("Client.Page", [], Page, () => [[], [], []]);
}

export class Animation extends Record {
    constructor(From, Range$, End, Step, Interval) {
        super();
        this.From = (From | 0);
        this.Range = (Range$ | 0);
        this.End = (End | 0);
        this.Step = (Step | 0);
        this.Interval = Interval;
    }
}

export function Animation$reflection() {
    return record_type("Client.Animation", [], Animation, () => [["From", int32_type], ["Range", int32_type], ["End", int32_type], ["Step", int32_type], ["Interval", float64_type]]);
}

export class MapInfo extends Record {
    constructor(Zoom, Center) {
        super();
        this.Zoom = Zoom;
        this.Center = Center;
    }
}

export function MapInfo$reflection() {
    return record_type("Client.MapInfo", [], MapInfo, () => [["Zoom", float64_type], ["Center", tuple_type(float64_type, float64_type)]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetPage", "SetRawData", "LoadData", "SetAnimation", "AnimationStep", "MapInfo"];
    }
}

export function Msg$reflection() {
    return union_type("Client.Msg", [], Msg, () => [[["Item", Page$reflection()]], [["Item", string_type]], [], [["Item", Animation$reflection()]], [], [["Item", MapInfo$reflection()]]]);
}

export class Model extends Record {
    constructor(Page, RawData, Markers, Edges, Animation, MapInfo) {
        super();
        this.Page = Page;
        this.RawData = RawData;
        this.Markers = Markers;
        this.Edges = Edges;
        this.Animation = Animation;
        this.MapInfo = MapInfo;
    }
}

export function Model$reflection() {
    return record_type("Client.Model", [], Model, () => [["Page", Page$reflection()], ["RawData", string_type], ["Markers", list_type(Marker$reflection())], ["Edges", list_type(tuple_type(Marker$reflection(), Marker$reflection()))], ["Animation", option_type(Animation$reflection())], ["MapInfo", option_type(MapInfo$reflection())]]);
}

export class GraphType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Mermaid", "GraphViz"];
    }
}

export function GraphType$reflection() {
    return union_type("Client.GraphType", [], GraphType, () => [[], []]);
}

export function toGraph(t, model) {
    const headerCode = (t.tag === 1) ? "digraph G {" : "graph TD";
    const footerCode = (t.tag === 1) ? "}" : "";
    const edges = model.Edges;
    const label_1 = (n) => head(split(" - ", head(lines(n.Title))));
    let nodeLabels;
    const e = collect((tupledArg) => ofArray([tupledArg[0], tupledArg[1]]), edges);
    const m = ofSeq_1(mapIndexed((i, n_2) => [n_2, toText(printf("N%i"))(i)], distinct(map(label_1, e), {
        Equals: (x_2, y_2) => (x_2 === y_2),
        GetHashCode: (x_2) => stringHash(x_2),
    })));
    nodeLabels = ofSeq_1(map((n_3) => [n_3, FSharpMap__get_Item(m, label_1(n_3))], e));
    return join(nl, concat([singleton(headerCode), sort(map_1((tupledArg_1) => {
        const g_1 = map((tuple_1) => tuple_1[0], tupledArg_1[1]);
        const n_4 = head(g_1);
        const level = (~(~(n_4.Weight * 100))) | 0;
        const tooltip = join("\\n", distinct(collect((n_1) => split(nl, n_1.Title), g_1), {
            Equals: (x_4, y_4) => (x_4 === y_4),
            GetHashCode: (x_4) => stringHash(x_4),
        }));
        const label = head(lines(label_1(n_4)));
        const node = tupledArg_1[0];
        if (t.tag === 1) {
            return toText(printf("%s [label=\"%s\", tooltip=\"%s\", level=%i];"))(node)(label)(tooltip)(level);
        }
        else {
            return toText(printf("%s(%s)"))(node)(label);
        }
    }, groupBy((tuple) => tuple[1], toList(nodeLabels), {
        Equals: (x_3, y_3) => (x_3 === y_3),
        GetHashCode: (x_3) => stringHash(x_3),
    })), {
        Compare: (x_5, y_5) => comparePrimitives(x_5, y_5),
    }), map_1((tupledArg_2) => {
        const y = FSharpMap__get_Item(nodeLabels, tupledArg_2[0]);
        const x = FSharpMap__get_Item(nodeLabels, tupledArg_2[1]);
        if (t.tag === 1) {
            return toText(printf("%s -\u003e %s;"))(x)(y);
        }
        else {
            return toText(printf("%s --\u003e %s"))(x)(y);
        }
    }, edges), singleton(footerCode)]));
}

export function loadData(model) {
    const nodes = mkData(model.RawData);
    const merge = (g) => {
        const x = head(g);
        return new Marker(x.Latitude, x.Longitude, "", join(nl, map((x_1) => x_1.Title, g)), min_1(map((x_2) => x_2.Weight, g), {
            Compare: (x_3, y) => comparePrimitives(x_3, y),
        }), min_1(map((x_4) => x_4.Year, g), {
            Compare: (x_5, y_1) => comparePrimitives(x_5, y_1),
        }), collect_1((x_6) => x_6.Properties, g));
    };
    const data = map_1((tupledArg) => merge(tupledArg[1]), groupBy((x_7) => [x_7.Latitude, x_7.Longitude], nodes, {
        Equals: (x_8, y_2) => equalArrays(x_8, y_2),
        GetHashCode: (x_8) => arrayHash(x_8),
    }));
    const edges = map_1((tupledArg_7) => {
        const g_3 = tupledArg_7[1];
        const xs = map_1((tuple_1) => tuple_1[0], g_3);
        const ys = map_1((tuple_2) => tuple_2[1], g_3);
        return [merge(xs), merge(ys)];
    }, groupBy((tupledArg_6) => {
        const x_14 = tupledArg_6[0];
        const y_7 = tupledArg_6[1];
        return [x_14.Latitude, x_14.Longitude, y_7.Latitude, y_7.Longitude];
    }, map_1((tuple) => tuple[1], map_1((tupledArg_4) => minBy((tupledArg_5) => tupledArg_5[0][1], tupledArg_4[1], {
        Compare: (x_13, y_6) => comparePrimitives(x_13, y_6),
    }), groupBy((tupledArg_3) => tupledArg_3[0][0], filter((tupledArg_2) => {
        const _arg5 = tupledArg_2[1];
        const y_4 = _arg5[1];
        const x_11 = _arg5[0];
        if (x_11.Ident === y_4.Ident) {
            return !equalArrays([x_11.Latitude, x_11.Longitude], [y_4.Latitude, y_4.Longitude]);
        }
        else {
            return false;
        }
    }, filter((tupledArg_1) => {
        const _arg2 = tupledArg_1[0];
        return _arg2[0] < _arg2[1];
    }, collect_1((x_10) => x_10, mapIndexed_1((i, x_9) => mapIndexed_1((j, y_3) => [[i, j], [x_9, y_3]], nodes), nodes)))), {
        Equals: (x_12, y_5) => (x_12 === y_5),
        GetHashCode: (x_12) => numberHash(x_12),
    }))), {
        Equals: (x_15, y_8) => equalArrays(x_15, y_8),
        GetHashCode: (x_15) => arrayHash(x_15),
    }));
    return new Model(model.Page, model.RawData, ofSeq(data), edges, model.Animation, model.MapInfo);
}

export function init() {
    return [loadData(new Model(new Page(0), data_1, empty(), empty(), void 0, void 0)), empty()];
}

export function initAnimation(m) {
    return new Animation(min_1(map((m_1) => m_1.Year, m.Markers), {
        Compare: (x, y) => comparePrimitives(x, y),
    }), 75, max_1(map((m_2) => m_2.Year, m.Markers), {
        Compare: (x_1, y_1) => comparePrimitives(x_1, y_1),
    }), 1, 0.01);
}

export function setAnimationTick(t, dispatch) {
    void window.setInterval((_arg1) => {
        if (animationActive()) {
            dispatch(new Msg(4));
        }
    }, ~(~(t * 1000)));
}

export function update(msg, currentModel) {
    let inputRecord;
    if (msg.tag === 1) {
        return [new Model(currentModel.Page, msg.fields[0], currentModel.Markers, currentModel.Edges, currentModel.Animation, currentModel.MapInfo), Cmd_none()];
    }
    else if (msg.tag === 2) {
        return [(inputRecord = loadData(currentModel), new Model(new Page(0), inputRecord.RawData, inputRecord.Markers, inputRecord.Edges, inputRecord.Animation, inputRecord.MapInfo)), Cmd_none()];
    }
    else if (msg.tag === 3) {
        animationActive(true, true);
        return [new Model(currentModel.Page, currentModel.RawData, currentModel.Markers, currentModel.Edges, msg.fields[0], currentModel.MapInfo), Cmd_none()];
    }
    else if (msg.tag === 4) {
        let m;
        const matchValue = currentModel.Animation;
        if (matchValue != null) {
            const a_1 = matchValue;
            const a$0027 = new Animation(a_1.From + a_1.Step, a_1.Range, a_1.End, a_1.Step, a_1.Interval);
            m = (new Model(currentModel.Page, currentModel.RawData, currentModel.Markers, currentModel.Edges, (a$0027.From > a$0027.End) ? (void 0) : a$0027, currentModel.MapInfo));
        }
        else {
            m = currentModel;
        }
        animationActive(m.Animation != null, true);
        return [m, Cmd_none()];
    }
    else if (msg.tag === 5) {
        return [new Model(currentModel.Page, currentModel.RawData, currentModel.Markers, currentModel.Edges, currentModel.Animation, msg.fields[0]), Cmd_none()];
    }
    else if (msg.fields[0].tag === 1) {
        return [new Model(new Page(1), currentModel.RawData, currentModel.Markers, currentModel.Edges, currentModel.Animation, currentModel.MapInfo), Cmd_none()];
    }
    else if (msg.fields[0].tag === 2) {
        return [new Model(new Page(2), currentModel.RawData, currentModel.Markers, currentModel.Edges, currentModel.Animation, currentModel.MapInfo), Cmd_none()];
    }
    else {
        return [new Model(new Page(0), currentModel.RawData, currentModel.Markers, currentModel.Edges, currentModel.Animation, currentModel.MapInfo), Cmd_none()];
    }
}

export const safeComponents = (() => {
    const components = react.createElement("div", {}, "Powered by: ", react.createElement("a", {
        href: "http://fable.io",
    }, "Fable"), ", ", react.createElement("a", {
        href: "https://elmish.github.io/elmish/",
    }, "Elmish"), ", ", react.createElement("a", {
        href: "https://mangelmaxime.github.io/Fulma",
    }, "Fulma"), ", ", react.createElement("a", {
        href: "https://leafletjs.com/",
    }, "Leaflet"));
    return react.createElement("p", {}, react.createElement("strong", {}, "AncestorsMap"), " project by ", react.createElement("a", {
        href: "https://jindraivanek.hashnode.dev",
    }, "Jindřich Ivánek"), ", GNU General Public License v3.0. ", components);
})();

export function button(txt, onClick) {
    return button_1(ofArray([new Option(2), new Option(0, new Color_IColor(4)), new Option(17, onClick)]), singleton(txt));
}

export const mapRef = createAtom(void 0);

export function view(model, dispatch) {
    let matchValue_2, matchValue_3, getColor, getTitle, opacity, zoomDynSize, getNumberOfLines, maxNumberOfLines, minNumberOfLines, markers, edges, opacity_1, dist, mapInfo, matchValue_1, center, m_2, info, updateInfo, props_25;
    return react.createElement("div", {}, navbar(singleton(new Option_1(0, new Color_IColor(4))), ofArray([Brand_div(empty(), singleton(react.createElement("div", {}, h2(empty())(singleton(title_1))))), Start_div(empty(), singleton(Item_div(empty(), singleton((matchValue_2 = model.Page, (matchValue_2.tag === 2) ? button("Back", (_arg2_1) => {
        dispatch(new Msg(2));
    }) : ((matchValue_2.tag === 0) ? columns_1(ofArray([new Option_2(9, "is-variable"), new Option_2(9, "is-1")]), ofArray([column(empty(), singleton(button("Load Data", (_arg3_1) => {
        dispatch(new Msg(0, new Page(1)));
    }))), column(empty(), singleton(button("Location Tree", (_arg4) => {
        dispatch(new Msg(0, new Page(2)));
    }))), column(empty(), singleton(button("Animate", (_arg5) => {
        dispatch(new Msg(3, initAnimation(model)));
    }))), column(empty(), singleton(defaultArg(map_2((a) => {
        const arg20_1 = (a.From + a.Range) | 0;
        return toText(printf("%i - %i"))(a.From)(arg20_1);
    }, model.Animation), "")))])) : button("Apply", (_arg1_1) => {
        dispatch(new Msg(2));
    })))))))])), (matchValue_3 = model.Page, (matchValue_3.tag === 1) ? columns_1(empty(), singleton(column(empty(), ofArray(["Data format (delimeter TAB): location | GPS(lat,lng) | year | name | note | type | properties", react.createElement("textarea", {
        defaultValue: model.RawData,
        onChange: (ev) => {
            dispatch(new Msg(1, ev.target.value));
        },
        rows: 20,
        cols: 120,
    })])))) : ((matchValue_3.tag === 2) ? columns_1(empty(), singleton(column(empty(), ofArray(["GraphViz graph format, copy paste to ", react.createElement("a", {
        href: "https://dreampuf.github.io/GraphvizOnline",
    }, "GraphvizOnline"), react.createElement("textarea", {
        defaultValue: toGraph(new GraphType(1), model),
        rows: 20,
        cols: 120,
    })])))) : (getColor = ((weight) => {
        let tupledArg;
        const tupledArg_2 = [0, 0, 0];
        const tupledArg_1 = [400, 50, 0];
        const step = weight;
        const linStep = (i, x, y) => (x + (i * (y - x)));
        tupledArg = [linStep(step, tupledArg_1[0], tupledArg_2[0]), linStep(step, tupledArg_1[1], tupledArg_2[1]), linStep(step, tupledArg_1[2], tupledArg_2[2])];
        const arg30 = (~(~tupledArg[2])) | 0;
        const arg20 = (~(~tupledArg[1])) | 0;
        const arg10 = (~(~tupledArg[0])) | 0;
        return toText(printf("rgb(%i,%i,%i)"))(arg10)(arg20)(arg30);
    }), (getTitle = ((x_1) => react.createElement("div", {}, ...map_1((l) => react.createElement("p", {}, l), lines(x_1)))), (opacity = ((m) => {
        const matchValue = model.Animation;
        if (matchValue == null) {
            return 1;
        }
        else {
            const r_2 = matchValue.Range | 0;
            const from = matchValue.From | 0;
            if ((from <= m.Year) ? (m.Year <= (from + r_2)) : false) {
                return 1;
            }
            else {
                return max_2((x_4, y_2) => comparePrimitives(x_4, y_2), 0.01, 0.75 - ((max_2((x_2, y_1) => comparePrimitives(x_2, y_1), from - m.Year, m.Year - (from + r_2)) / r_2) * 0.5));
            }
        }
    }), (zoomDynSize = ((x_5) => (x_5 * Math.pow(1.8, 12 - defaultArg(map_2((x_6) => x_6.Zoom, model.MapInfo), 12)))), (getNumberOfLines = ((x_7) => length(lines(x_7.Title))), (maxNumberOfLines = max_1(map(getNumberOfLines, model.Markers), {
        Compare: (x_8, y_3) => comparePrimitives(x_8, y_3),
    }), (minNumberOfLines = min_1(map(getNumberOfLines, model.Markers), {
        Compare: (x_9, y_4) => comparePrimitives(x_9, y_4),
    }), (markers = map((x_12) => {
        const extraProps = choose((_arg1) => {
            if (_arg1.tag === 1) {
                return _arg1.fields[0];
            }
            else {
                return void 0;
            }
        }, mkProperties(x_12.Properties));
        const props_9 = append(extraProps, ofSeq(delay(() => append_1(singleton_1(CircleProps_Custom_433E080("center", [x_12.Longitude, x_12.Latitude])), delay(() => {
            let minValue;
            return append_1((!exists((_arg2) => {
                if (_arg2.tag === 17) {
                    return true;
                }
                else {
                    return false;
                }
            }, extraProps)) ? singleton_1(new CircleProps(17, zoomDynSize((minValue = 200, minValue + ((800 - minValue) * Math.sqrt((getNumberOfLines(x_12) - minNumberOfLines) / max_2((x_11, y_5) => comparePrimitives(x_11, y_5), 1, maxNumberOfLines - minNumberOfLines))))))) : empty_1(), delay(() => append_1(singleton_1(new CircleProps(4, getColor(x_12.Weight))), delay(() => singleton_1(new CircleProps(6, opacity(x_12)))))));
        })))));
        return react.createElement(Circle, keyValueList(props_9, 1), react.createElement(Popup, {}, getTitle(x_12.Title)), react.createElement(Tooltip, {
            sticky: true,
        }, getTitle(x_12.Title)));
    }, filter_1((m_1) => (opacity(m_1) > 0.01), model.Markers)), (edges = (opacity_1 = ((tupledArg_3) => ((opacity(tupledArg_3[0]) + opacity(tupledArg_3[1])) / 2)), collect_1((tupledArg_4) => {
        let props_19, props_21;
        const x_14 = tupledArg_4[0];
        const y_7 = tupledArg_4[1];
        const opacity_2 = new PolylineProps(6, opacity_1([x_14, y_7]));
        const extraProps_1 = choose((_arg3) => {
            if (_arg3.tag === 0) {
                return _arg3.fields[0];
            }
            else {
                return void 0;
            }
        }, mkProperties(append(x_14.Properties, y_7.Properties)));
        return cons((props_19 = append(ofArray([new PolylineProps(29, [[x_14.Longitude, x_14.Latitude], [y_7.Longitude, y_7.Latitude]]), new PolylineProps(4, getColor(max_2((x_15, y_8) => comparePrimitives(x_15, y_8), x_14.Weight, y_7.Weight))), opacity_2]), extraProps_1), react.createElement(Polyline, keyValueList(props_19, 1), react.createElement(Popup, {}, react.createElement("div", {}, getTitle(x_14.Title), getTitle(y_7.Title))), react.createElement(Tooltip, {
            sticky: true,
        }, react.createElement("div", {}, getTitle(x_14.Title), getTitle(y_7.Title))))), USE_ARROWS ? singleton((props_21 = append(ofArray([new PolylineProps(29, Array.from(map_1((x_16) => x_16, arrowPolyLine(zoomDynSize(0.003), x_14.Longitude, x_14.Latitude, y_7.Longitude, y_7.Latitude)))), new PolylineProps(4, getColor(max_2((x_17, y_9) => comparePrimitives(x_17, y_9), x_14.Weight, y_7.Weight))), opacity_2]), extraProps_1), react.createElement(Polyline, keyValueList(props_21, 1)))) : empty());
    }, filter((e) => (opacity_1(e) > 0.01), model.Edges))), (dist = ((x_19, y_11) => Math.sqrt(Math.pow(x_19.Longitude - y_11.Longitude, 2) + Math.pow(x_19.Latitude - y_11.Latitude, 2))), (mapInfo = (matchValue_1 = model.MapInfo, (matchValue_1 != null) ? matchValue_1 : (center = (m_2 = minBy((arg10_1) => ((y_12) => sumBy((x_20) => dist(x_20, y_12), model.Markers, {
        GetZero: () => 0,
        Add: (x_21, y_13) => (x_21 + y_13),
    }))(arg10_1), model.Markers, {
        Compare: (x_22, y_14) => comparePrimitives(x_22, y_14),
    }), [m_2.Longitude, m_2.Latitude]), (info = (new MapInfo(12 - (Math.log(max_1(collect((x_23) => map((y_15) => dist(x_23, y_15), model.Markers), model.Markers), {
        Compare: (x_24, y_16) => comparePrimitives(x_24, y_16),
    }) * 4) / Math.log(2)), center)), (dispatch(new Msg(5, info)), info)))), (updateInfo = ((m_3) => {
        console.log(some(m_3));
        dispatch(new Msg(5, new MapInfo(m_3.viewport.zoom, [m_3.viewport.center[0], m_3.viewport.center[1]])));
    }), columns_1(empty(), singleton(column(empty(), singleton((props_25 = ofArray([new MapProps(36, mapInfo.Center), new MapProps(44, true), new MapProps(42, mapInfo.Zoom), new MapProps(4, 0.1), new MapProps(38, "myMap"), MapProps_Style_7213C43C(singleton(new CSSProp(189, "650px"))), new MapProps(88, (m_4) => {
        mapRef(some(m_4), true);
    }), new MapProps(75, (x_25) => {
        iterate(updateInfo, toArray(mapRef()));
    }), new MapProps(73, (x_26) => {
        iterate(updateInfo, toArray(mapRef()));
    }), new MapProps(62, (x_27) => {
        iterate(updateInfo, toArray(mapRef()));
    })]), react.createElement(Map$, keyValueList(props_25, 1), ...ofSeq(delay(() => append_1(singleton_1(react.createElement(TileLayer, {
        attribution: "\u0026copy; \u003ca href=\"https://www.openstreetmap.org/copyright\"\u003eOpenStreetMap\u003c/a\u003e contributors",
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    })), delay(() => append_1(markers, delay(() => edges)))))))))))))))))))))))))), footer(empty(), singleton(content(singleton(new Option_3(3, singleton(new Modifier_IModifier(5, new Screen(0), new TextAlignment_Option(0))))), ofArray([safeComponents, footer_1])))));
}

ProgramModule_run(Program_withReactBatched("elmish-app", ProgramModule_withSubscription((_arg1) => Cmd_ofSub((dispatch_1) => {
    setAnimationTick(0.1, dispatch_1);
}), ProgramModule_mkProgram(init, (msg, currentModel) => update(msg, currentModel), (model, dispatch) => view(model, dispatch)))));

export function main() {
    toConsole(printf("%s"))(data_1);
}

